<template>
  <div class="disturb-student">
    <el-table
      :data="showList"
      style="width: 100%"
      tooltip-effect="dark"
      @selection-change="handleSelectionChange"
      class="common-edit-button"
    >
      <el-table-column label="#" type="index"> </el-table-column>
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="studentNumber"
        width="150px"
        :show-overflow-tooltip="true"
        label="学号"
      >
      </el-table-column>
      <el-table-column
        prop="studentName"
        width="150px"
        :show-overflow-tooltip="true"
        label="姓名"
      >
      </el-table-column>
      <el-table-column width="150px" label="设备IMEI" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.deviceId ? '' : '#fc3e39' }">
            {{ scope.row.deviceId ? scope.row.deviceId : "未绑定设备" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="150px" label="在线状态">
        <template slot-scope="scope">
          <span :style="{ color: scope.row.status == 1 ? '#2abd72' : '#fc3e39' }">
            {{ scope.row.status == 1 ? "在线" : "离线" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="150px" label="免打扰时间段">
        <template slot-scope="scope">
          <!-- <span
            v-if="!scope.row.timeQuantum"
            :style="{ color: scope.row.timeQuantum ? '' : '#909399' }"
          >
            {{ scope.row.timeQuantum ? changeTime(scope.row.timeQuantum) : "未设置" }}
          </span>
          <span
            v-else
            v-for="(item, index) in changeTime(scope.row.timeQuantum)"
            :key="index"
          >
            {{ item
            }}{{
              changeTime(scope.row.timeQuantum).indexOf(item) !==
              changeTime(scope.row.timeQuantum).length - 1
                ? "、"
                : ""
            }}
          </span> -->
          <span
            v-for="(item, index) in scope.row.timePeriod"
            :key="index"
            :style="{ color: scope.row.timePeriod.length ? '' : '#909399' }"
          >
            {{ item.time ? changeTime(item.time) : "未设置" }}<br />
          </span>
        </template>
      </el-table-column>
      <el-table-column label="免打扰周期" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <span
            :style="{ color: scope.row.timePeriod.length ? '' : '#909399' }"
            v-for="(item, index) in scope.row.timePeriod"
            :key="index"
          >
            {{ item.days ? changeDays(item.days) : "未设置" }} <br />
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column width="120px" label="时间段二">
        <template slot-scope="scope">
          <span :style="{'color': scope.row.afternoon ? '' : '#909399'}">
          {{ scope.row.afternoon ? changeTime(scope.row.afternoon) : "未设置" }}
          </span>
        </template>
      </el-table-column>
      <el-table-column width="120px" label="时间段三">
        <template slot-scope="scope">
          <span :style="{'color': scope.row.night ? '' : '#909399'}">
          {{ scope.row.nigth ? changeTime(scope.row.night) : "未设置" }}
          </span>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  props: {
    showList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    // 把字符串 '1000-1100' 转换成 '10:00-11:00'
    // changeTime(time) {
    //   let list = time.split(",");
    //   // console.log("传过来的time==>",list);
    //   let newList = [];
    //   list.forEach((item) => {
    //     // console.log("原来的时间格式==>",item);
    //     let newTime = item.split("-");
    //     let begin = newTime[0].slice(0, 2) + ":" + newTime[0].slice(2); // 10:00格式
    //     let end = newTime[1].slice(0, 2) + ":" + newTime[1].slice(2);
    //     item = `${begin}-${end}`;
    //     newList.push(item);
    //   });
    //   // console.log("新的时间格式==>", newList);
    //   return newList;
    // },
    changeTime(item) {
      let newTime = item.split("-");
      let begin = newTime[0].slice(0, 2) + ":" + newTime[0].slice(2); // 10:00格式
      let end = newTime[1].slice(0, 2) + ":" + newTime[1].slice(2);
      return (item = `${begin}-${end}`);
    },
    changeDays(days) {
      let list = ["一", "二", "三", "四", "五", "六", "日"];
      let newList = [];
      for (let i = 0; i < list.length; i++) {
        if (days.indexOf(i + 1) != -1) {
          newList.push(list[i]);
        }
      }
      let str = newList.join("、");
      return str;
    },
    // 选择
    handleSelectionChange(val) {
      // console.log(val);
      this.selectList = val;
      let list = [];
      this.selectList.forEach((item) => {
        list.push(item.deviceId);
      });
      this.$emit("multipleDelete", list);
      // this.selectList = val;
      // this.$emit("multipleSelect", this.selectList);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./disturb-student.scss";
</style>
